import React from 'react'
import { Helmet } from 'react-helmet'
import detector from 'util/browser-detect'

const BrowserDetectorHelmet = () => {
  return (
    <Helmet
      bodyAttributes={{
        'data-browser-detected': detector().name.toLowerCase(),
      }}
    />
  )
}
export default BrowserDetectorHelmet
